<template>
  <el-row class="main-container">
    <el-col
      :sm="8"
      :lg="7"
      :xl="6"
      class="goals-main-list">
      <el-row>
        <el-col class="main-header">
          <h1>Objetivos</h1>
          <!-- <el-button
            circle
            @click="onShowGoalsPanel">
            <i class="icon-plus"/>
          </el-button> -->
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <goals-list
            :goals-items="listItems"
            :goals="itemsGoals"
            :hide-actions="true"
            :focus-first="true"
            goals-items-type="territorial"
            @clickOnItem="clickOnItem"
            @onEdit="onEdit"/> <!-- TODO: change to respective type -->
        </el-col>
      </el-row>
    </el-col>
    <el-col
      :sm="16"
      :lg="17"
      :xl="18"
      class="container-section-main">
      <goals-chart-preview
        v-if="listItems.length > 0"
        :goals="currentGoals"
        :item="currentGoalItem"
        :met-goals="metGoals"
        :hide-parent="true"
        item-type="territorial"/> <!-- TODO: change to respective type -->
      <div
        v-else
        class="no-data">
        <div>
          <i class="icon-alert-triangle"/>
          <h1>No se encontraron registros</h1>
        </div>
      </div>
    </el-col>
    <goals-create-panel
      v-if="showGoalsPanel"
      :edit="edit"
      :items="listItems"
      :item="currentGoalItem"
      :goals="currentGoals"
      item-type="branch"
      @closeModal="onCloseGoalsPanel"
      @onCreate="reloadList"/> <!-- TODO: change to respective type -->
  </el-row>
</template>

<script>
/**
*
* GoalsDealerView Component
*
* @author Eduardo Espinosa
* @copyright 2018, Marciano Studio S.C.
*/
import GoalsList from '@/modules/goals/goals-dealer-list.vue'
import GoalsChartPreview from '@/modules/goals/goals-chart-preview.vue'
import GoalsCreatePanel from './goals-create-panel.vue'
import GoalsGuards from '@/guards/goals.guards'
import multiguard from 'vue-router-multiguard'

export default {
  name: 'GoalsZoneView',
  components: {
    GoalsList,
    GoalsChartPreview,
    GoalsCreatePanel
  },
  data () {
    return {
      showGoalsPanel: false,
      edit: false
    }
  },
  computed: {
    listItems () {
      return this.$store.getters['zones/items'] // TODO: change to respective resource
    },
    itemsGoals () {
      return this.$store.getters['zoneGoals/items'] // TODO: change to respective resource
    },
    metGoals () {
      return this.$store.getters['zoneGoals/metGoals'] // TODO: change to respective resource
    },
    currentGoalItem () {
      let _currentId = this.$route.params.id || (this.listItems.length ? this.listItems[0].id : null)
      if (!_currentId) {
        return {}
      }
      return this.listItems.find(item => {
        return parseInt(_currentId) === parseInt(item.id)
      })
    },
    currentGoals () {
      let _currentId = this.$route.params.id || (this.listItems.length ? this.listItems[0].id : null)
      if (!_currentId) {
        return []
      }
      return this.itemsGoals.filter(goal => {
        return parseInt(_currentId) === parseInt(goal.territorialId) // TODO: change to respective id
      })
    }
  },
  methods: {
    onEdit (item) {
      this.clickOnItem(item)
      this.edit = true
      this.showGoalsPanel = true
      this.$forceUpdate()
    },
    onShowGoalsPanel () {
      this.edit = false
      this.showGoalsPanel = true
    },
    onCloseGoalsPanel () {
      this.showGoalsPanel = false
    },
    clickOnItem (item) {
      this.$router.push({...this.$route, params: {id: item.id}})
    },
    reloadList () {
      this.$router.push({...this.$route, query: {...this.$route.query, reload: Date.now()}})
    }
  },
  beforeRouteUpdate: multiguard([GoalsGuards.onQueryZoneGoalItems(),
    GoalsGuards.onQuery('zoneGoals'),
    GoalsGuards.onQueryMetGoals('zoneGoals', 'zones/items')
  ]) // TODO: change to respective resource
}
</script>

<style lang='scss' scoped>
    .main-container{
    height: 100%;
    width: 100%;
    overflow: hidden;
    .goals-main-list{
      height: calc(100% - 60px);
      padding: 0 15px;
      border-right: 1px solid $border-primary;
      position: relative;
      overflow: auto;
      background-color: #ffffff;
      .main-header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        h1 {
          @include font-primary(21px, regular);
          color: #707070;
        }
        .el-button {
          background-color: $primary;
          border: none;
          color: #ffffff;
          box-shadow: 0 3px 6px 0 rgba(#E7120E, 0.5);
        }
      }
    }
    .container-section-main {
      height: calc(100% - 60px);
      position: relative;
      overflow: auto;
      margin-right: -50px;
      background-color: $secondary;
      padding: 30px;
    }
  }

  .no-data {
    background-color: #fff;
    border: 1px solid $border-primary;
    border-radius: 3px;
    height: 500px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    div {
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
      justify-content: center;
      i {
        font-size: 60px;
        color: $icon;
      }
      h1 {
        font-size: 22px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/app/goals/goals-zone.view.vue